<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForSecurityMasterForm
        ref="feesForSecurityMasterForm"
        v-model="feesForSecurityMasterFormModel"
        label-width="10em"
        formMode="edit"
        :editDisabledMode="editDisabledMode"
        tableType="SECURITY"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForSecurityMasterForm from '@/components/organisms/dialog/feeMaster/FeesForSecurityMasterForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FeesForSecurityMasterForm,
    EditDialogFooter
  },
  mixins: [
  ],
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForSecurityMasterFormModel: {
        // billing_ym: this.getDefaultBillingYm(),
        charge_year: undefined,
        route_code: undefined,
        passenger_charge: undefined,
        cargo_charge: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return this.feesForSecurityMasterFormModel.regist_type === '1' || parseInt(this.feesForSecurityMasterFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.feesForSecurityMasterForm.validate()
        .then((valid) => {
          return this.$axios.put('/fees-for-security-master', this.feesForSecurityMasterFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          // this.$emit('refresh', this.feesForSecurityMasterFormModel.billing_ym)
          this.$emit('refresh', this.feesForSecurityMasterFormModel.charge_year)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      // const trimItem = ['bill_to_code', 'destination_airport_code']
      this.$nextTick(() => {
        this.$refs.feesForSecurityMasterForm.clearFields()
        Object.keys(this.feesForSecurityMasterFormModel)
          .forEach((x) => {
            // if (trimItem.includes(x)) {
            //   this.currentRow[x] = this.currentRow[x].trimEnd()
            // }
            this.$set(this.feesForSecurityMasterFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
